module.exports = __webpack_public_path__ + "media/images/logos/bcs-logo-with-bg-c253ff206f622fbaee95aa1e4e023642.svg";